import main from './main';

const themes = {
  main,
};

export default themes;
